import React, {createContext, useReducer} from 'react';
import { draftReducer } from '../reducers/draftReducer';
import { rankingsReducer } from '../reducers/rankingsReducer';
import { sponsorsReducer } from '../reducers/sponsorsReducer';

const draftStore = createContext();
const { Provider: DraftProvider } = draftStore;

const rankingsStore = createContext();
const { Provider: RankingsProvider } = rankingsStore;

const sponsorsStore = createContext();
const { Provider: SponsorsProvider } = sponsorsStore;

const DraftStateProvider = ({ children }) => {
    const [ combinedReducer , combinedState ] = draftReducer;
    const [ state, dispatch ] = useReducer(combinedReducer, combinedState);
    return <DraftProvider value={{ state, dispatch}}>{children}</DraftProvider>
}

const RankingsStateProvider = ({ children }) => {
    const [ combinedReducer , combinedState ] = rankingsReducer;
    const [ state, dispatch ] = useReducer(combinedReducer, combinedState);
    return <RankingsProvider value={{ state, dispatch}}>{children}</RankingsProvider>
}

const SponsorsStateProvider = ({ children }) => {
    const [ reducer , initialState ] = sponsorsReducer;
    const [ state, dispatch ] = useReducer(reducer, initialState);
    return <SponsorsProvider value={{ state, dispatch }}>{children}</SponsorsProvider>
}

export { draftStore, rankingsStore, sponsorsStore, DraftStateProvider, RankingsStateProvider, SponsorsStateProvider } ;
